angular
	.module('WizApp')
	.directive('togglable', ['$document', function ($document) {
        return {
            restrict: 'A',
            scope: {
                id: '@',
                onClose: '&',
                togglable: '=',
                selector: '@',
                onToggle: '&?'
            },
            link: function (scope, element) {
                $document.bind('click', (event) => {
                    scope.selector = scope.selector || 'v35__dropdown__toggle';

                    let clickedOnToggable = (element.attr('id') === angular.element(event.target).attr('id')) || element
                        .find(event.target)
                        .length > 0;
                    let toggleDisabled = Boolean(angular
                        .element(element)
                        .find(`.${scope.selector}`)
                        .attr('disabled'));

                    if (!clickedOnToggable || toggleDisabled) {
                        scope.togglable = false;
                    } else {
                        let clickedOnToggle = angular.element(event.target).hasClass(scope.selector);
                        let clickedOnToggleChild = (angular.element(element).find(`.${scope.selector}`).find(event.target).length > 0);

                        if (clickedOnToggle || clickedOnToggleChild) {
                            scope.togglable = !scope.togglable;
                        } else {
                            scope.togglable = true;
                        }
                    }
                    // avoid the scroll of body on xs device when dropdown is open
                    let body = $document.find('body');
                    if (scope.togglable && !body.hasClass('overflow-hidden-' + scope.id)) {
                        body.addClass('overflow-hidden-' + scope.id);
                    } else if (!scope.togglable && body.hasClass('overflow-hidden-' + scope.id)) {
                        body.removeClass('overflow-hidden-' + scope.id);
                        scope.onClose();
                    }

                    scope.$apply();

                    if (scope.onToggle) {
                        scope.onToggle({
                            state: {
                                id: scope.id,
                                toggled: scope.togglable,
                            }
                        });
                    }
                });
            }
        };
    }])
;
